const formatEur = (v) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v);

/**
 * Badge "Paga a rate con Klarna".
 * - Da 35€ fino a payIn3Max: mostra "3 rate da €X senza interessi".
 * - Oltre payIn3Max: messaggio generico "Paga a rate con Klarna"
 *   (l'importo esatto delle rate viene definito da Klarna al checkout).
 */
export const KlarnaBadge = ({ amount, min = 35, payIn3Max = 2000, className = '' }) => {
  if (!amount || amount < min) return null;
  const showRate = amount <= payIn3Max;
  const rate = amount / 3;
  return (
    <div
      className={`flex items-center gap-2 text-small text-muted ${className}`}
      data-testid="klarna-badge"
    >
      <span className="inline-flex items-center rounded-md bg-[#FFB3C7] text-ink font-semibold px-2 py-0.5 text-xs tracking-tight">
        Klarna
      </span>
      {showRate ? (
        <span>
          oppure 3 rate da{' '}
          <span className="text-ink font-medium">{formatEur(rate)}</span> senza interessi
        </span>
      ) : (
        <span>
          Paga a rate con <span className="text-ink font-medium">Klarna</span>
        </span>
      )}
    </div>
  );
};
